import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { TicketingEvent } from '@wbk/api';
import { Button } from '@wbk/ui';
import { formatDate } from '@wbk/utils';
import PaymentMethods from '@/components/common/PaymentMethods';

type Props = {
  event: TicketingEvent;
};

const StickyMatchInfo = ({ event }: Props) => {
  const { locale } = useRouter();
  const { t } = useTranslation();

  return (
    <div className='sticky top-2 divide-white/40'>
      <div className='event-info flex items-center justify-between py-6'>
        <div>
          <h3 className='pb-1'>{t('event:date')}</h3>
          <p data-info='time' data-testid='time'>
            {event.tbc
              ? 'TBC'
              : `${formatDate(event.start_date_time, locale, { day: '2-digit' })} ${formatDate(event.start_date_time, locale, { month: 'long' })} ${formatDate(event.start_date_time, locale, { year: 'numeric' })} | ${formatDate(event.start_date_time, locale, { timeStyle: 'short' })}`}
          </p>
        </div>
        <Image
          src='/icons/common/calendar-white.svg'
          width={25}
          height={26}
          alt={t('event:date')}
        />
      </div>
      <hr />
      <div className='event-info flex items-center justify-between py-6'>
        <div>
          <h3 className='pb-1'>{t('event:location')}</h3>
          <a
            className='event-info hover:underline'
            href={`https://www.google.com/maps/search/?api=1&query=${event.location.lat},${event.location.lng}`}
            data-info='location'
            data-testid='location'
          >
            {event.venue_name}
          </a>
        </div>
        <Image
          src='/icons/common/venue-white.svg'
          width={25}
          height={19}
          alt={t('event:location')}
        />
      </div>
      <hr />
      <div className='mt-10'>
        <h3 className='pb-2 pt-4'>{t('event:need_help')}</h3>
        <Button
          as='a'
          shape='outlined'
          theme='white'
          className='w-full'
          href='https://ittihadclub.sa/contact-us'
          data-info='support'
          target='_blank'
          rel='noopener noreferrer'
        >
          {t('event:support')}
        </Button>

        <div className='rounded-lg pt-12 lg:hidden'>
          <PaymentMethods />
        </div>
      </div>
    </div>
  );
};

export default StickyMatchInfo;
